"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useTermsAndConditionsConsent = void 0;
var _checkoutUtils = require("@ori/checkout-utils");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _react = require("react");
var _logger = require("../logger");
const useTermsAndConditionsConsent = (props)=>{
    var _requiredTerms_collection_find, _requiredTerms_collection_find1;
    const { customerId } = props;
    const [isTermsAndConditionsDialogOpen, setIsTermsAndConditionsDialogOpen] = (0, _react.useState)(false);
    const [termId, setTermId] = (0, _react.useState)('');
    (0, _logger.logDebug)('useTermsAndConditionsConsent() hook called.');
    const swrOptions = {
        ..._checkoutUtils.errorHandlingSwrOptions,
        enabled: true,
        onSuccess: ()=>(0, _logger.logDebug)('useGetCustomerRequiredTerms() hook finished successfully.')
    };
    const { data: requiredTerms } = (0, _globalApiClientReact.useGetCustomerRequiredTerms)(customerId, undefined, undefined, {
        swr: swrOptions
    });
    const termsAndConditionsTermId = requiredTerms === null || requiredTerms === void 0 ? void 0 : (_requiredTerms_collection_find = requiredTerms.collection.find((terms)=>terms.type === _globalApiClientReact.GlobalCustomersRequiredTermDtoType.TermsAndConditions)) === null || _requiredTerms_collection_find === void 0 ? void 0 : _requiredTerms_collection_find.termId;
    const privacyPolicyTermId = requiredTerms === null || requiredTerms === void 0 ? void 0 : (_requiredTerms_collection_find1 = requiredTerms.collection.find((terms)=>terms.type === _globalApiClientReact.GlobalCustomersRequiredTermDtoType.PrivacyPolicy)) === null || _requiredTerms_collection_find1 === void 0 ? void 0 : _requiredTerms_collection_find1.termId;
    const toggleDialog = (0, _react.useCallback)((consentTermId)=>{
        if (consentTermId) {
            setTermId(consentTermId);
        }
        setIsTermsAndConditionsDialogOpen((prevState)=>!prevState);
    }, []);
    const toggleTermsAndConditionsDialog = (0, _react.useCallback)(()=>{
        toggleDialog(termsAndConditionsTermId);
    }, [
        termsAndConditionsTermId,
        toggleDialog
    ]);
    const togglePrivacyPolicyDialog = (0, _react.useCallback)(()=>{
        toggleDialog(privacyPolicyTermId);
    }, [
        privacyPolicyTermId,
        toggleDialog
    ]);
    const termsAndConditionsDialogProps = {
        isOpen: isTermsAndConditionsDialogOpen,
        onClose: toggleDialog,
        termId
    };
    return {
        privacyPolicyTermId,
        termsAndConditionsDialogProps,
        termsAndConditionsTermId,
        togglePrivacyPolicyDialog,
        toggleTermsAndConditionsDialog
    };
};
exports.useTermsAndConditionsConsent = useTermsAndConditionsConsent;
